<div class="title title--xs" *ngIf="(field)">

  <ng-container *ngIf="displayText.includes('<a'); else plainText">
    <span [innerHTML]="displayText"></span>
  </ng-container>
  <ng-template #plainText>
    {{ displayText }}
  </ng-template>

  <span *ngIf="field.ruleId === optionalRuleId">(Optional)</span>
</div>